"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("~/store/types");
const events_1 = require("~/consts/events");
const ConnectionObject_3d_1 = __importDefault(require("../utils/ConnectionObject.3d"));
const Viewer_1 = __importDefault(require("../Viewer"));
const utils_1 = require("../utils");
const utils_3d_1 = require("../utils/utils.3d");
const FastenersUtils_1 = require("../utils/FastenersUtils");
const commands_1 = require("../commands");
const TSlotCoverUpdateHelper_1 = require("./SlotCoverSnapping/TSlotCoverUpdateHelper");
const addFastenersCallback = (objects, parent, useGroupBoxes = true, useCollision = true) => {
    objects.forEach((object) => {
        parent.add(object);
        if (useGroupBoxes) {
            Viewer_1.default.instance.collisionProcessor.notifyObjectAdded(object);
        }
    });
    if (useCollision) {
        objects.forEach((object) => Viewer_1.default.instance.collisionProcessor.updateCollisions(object));
    }
};
const removeFastenersCallback = (objects) => {
    if (objects.length) {
        new commands_1.RemoveObjectCommand(objects, Viewer_1.default.instance, Viewer_1.default.instance.getDesignProMain().historyService).execute(false);
    }
};
class ConnectionManager {
    constructor(viewer) {
        this.inProgressAddConnections = [];
        this.connections = new Map();
        this.boundAddFasteners = (event) => {
            var _a;
            const fastenersData = event.detail;
            (_a = fastenersData.connectionUuids) === null || _a === void 0 ? void 0 : _a.forEach((connectionId) => {
                const connection = this.getConnectionByUUID(connectionId);
                if (connection) {
                    connection.fastenerItemNumber = fastenersData.itemNumber;
                    (0, TSlotCoverUpdateHelper_1.updateTSlotCoversOnFastenerChange)(connection);
                }
            });
        };
        this.boundUpdateFasteners = (event) => {
            const fastenersData = event.detail;
            const connection = this.getConnection(fastenersData.mainItem.uuid, fastenersData.connectedItem.uuid);
            if (connection) {
                connection.fastenerItemNumber = fastenersData.createItems[0].itemNumber;
                (0, TSlotCoverUpdateHelper_1.updateTSlotCoversOnFastenerChange)(connection);
            }
        };
        this.boundDeleteFasteners = (event) => {
            const fastenersData = event.detail;
            const connection = this.getConnectionByUUID(fastenersData.connectionUuid);
            if (connection) {
                connection.fastenerItemNumber = undefined;
                (0, TSlotCoverUpdateHelper_1.updateTSlotCoversOnFastenerChange)(connection);
            }
        };
        this.viewer = viewer;
        document.body.addEventListener(events_1.addFasteners, this.boundAddFasteners, false);
        document.body.addEventListener(events_1.updateFasteners, this.boundUpdateFasteners, false);
        document.body.addEventListener(events_1.deleteFasteners, this.boundDeleteFasteners, false);
    }
    dispose() {
        document.body.removeEventListener(events_1.addFasteners, this.boundAddFasteners, false);
        document.body.removeEventListener(events_1.updateFasteners, this.boundUpdateFasteners, false);
        document.body.removeEventListener(events_1.deleteFasteners, this.boundDeleteFasteners, false);
    }
    getConnectionObject(mainObjectUUID, connectedObjectUUID) {
        var _a;
        return (_a = this.connections.get(mainObjectUUID)) === null || _a === void 0 ? void 0 : _a.get(connectedObjectUUID);
    }
    getConnection(mainObjectUUID, connectedObjectUUID) {
        var _a;
        return (_a = this.getConnectionObject(mainObjectUUID, connectedObjectUUID)) === null || _a === void 0 ? void 0 : _a.getConnection();
    }
    getConnectionByUUID(connectionId) {
        let connection;
        const allConnectionObjectsAsArray = Array.from(this.connections.values());
        for (let i = 0; i < allConnectionObjectsAsArray.length; i += 1) {
            const currConnectionObjects = allConnectionObjectsAsArray[i];
            const currConnectionObjectsAsArray = Array.from(currConnectionObjects.values());
            for (let j = 0; j < currConnectionObjectsAsArray.length; j += 1) {
                const connectionObject = currConnectionObjectsAsArray[j];
                if (connectionObject.getConnection().connectionUuid === connectionId) {
                    connection = connectionObject.getConnection();
                    break;
                }
            }
            if (connection) {
                break;
            }
        }
        return connection;
    }
    getConnectionObjects(mainObjectUUID) {
        var _a;
        const connectionObjects = [];
        (_a = this.connections.get(mainObjectUUID)) === null || _a === void 0 ? void 0 : _a.forEach((connectionObject) => connectionObjects.push(connectionObject));
        return connectionObjects;
    }
    getConnections(mainObjectUUID) {
        var _a;
        const connections = [];
        (_a = this.connections
            .get(mainObjectUUID)) === null || _a === void 0 ? void 0 : _a.forEach((connectionObject) => connections.push(connectionObject.getConnection()));
        return connections;
    }
    findConnectionObjectBetween(firstObjectUUID, secondObjectUUID) {
        let connectionObject = this.getConnectionObject(firstObjectUUID, secondObjectUUID);
        connectionObject !== null && connectionObject !== void 0 ? connectionObject : (connectionObject = this.getConnectionObject(secondObjectUUID, firstObjectUUID));
        return connectionObject;
    }
    findConnectionBetween(firstObjectUUID, secondObjectUUID) {
        var _a;
        return (_a = this.findConnectionObjectBetween(firstObjectUUID, secondObjectUUID)) === null || _a === void 0 ? void 0 : _a.getConnection();
    }
    getRelatedConnections(object) {
        return this.getRelatedConnectionObjects(object).map((connectionObject) => connectionObject.getConnection());
    }
    getRelatedConnectionObjects(object) {
        return (0, utils_3d_1.isFastener)(object)
            ? this.getFastenerRelatedConnectionObjects(object)
            : this.getObjectRelatedConnectionObjects(object);
    }
    clearConnections() {
        this.connections.forEach((objectConnections) => {
            objectConnections.forEach((connectionObject) => {
                connectionObject.removeFromParent();
            });
        });
        this.connections.clear();
    }
    static getVisualizationParams(fastenerItem) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { item_number: itemNumber } = fastenerItem.item;
        const slotNumber = (_c = (_b = (_a = fastenerItem.connectionItems) === null || _a === void 0 ? void 0 : _a.at(0)) === null || _b === void 0 ? void 0 : _b.slotNumbers) === null || _c === void 0 ? void 0 : _c.at(0);
        const { distanceToTheEdge, holeDepth } = fastenerItem;
        const distanceToSnappingPoint = (_g = (_f = (_e = (_d = fastenerItem.connectionItems) === null || _d === void 0 ? void 0 : _d.at(0)) === null || _e === void 0 ? void 0 : _e.slotNumbersWithDistanceToSnappingPoint) === null || _f === void 0 ? void 0 : _f.at(0)) === null || _g === void 0 ? void 0 : _g.distance;
        return {
            item_number: itemNumber,
            distanceToTheEdge: distanceToTheEdge !== null && distanceToTheEdge !== void 0 ? distanceToTheEdge : distanceToSnappingPoint,
            holeDepth,
            slotNumber,
        };
    }
    restoreConnection(mainObject, connectedObject, mainItem, connectedItem, connectionType, connectionUUID, fastenerProjectItems) {
        const connection = {
            actionType: types_1.ACTION_TYPE.ADD,
            connectionType,
            connectionUuid: connectionUUID,
            items: [mainItem, connectedItem],
        };
        const fastenerItems = fastenerProjectItems.map((fastenerProjectItem) => ConnectionManager.getVisualizationParams(fastenerProjectItem));
        const connectionObject = new ConnectionObject_3d_1.default(connection, mainObject, connectedObject);
        connectionObject.setAddFastenersCallback(addFastenersCallback);
        connectionObject.setRemoveFastenersCallback(removeFastenersCallback);
        this.setConnectionObject(mainObject, connectedObject, connectionObject);
        const actionTypeOnFailure = (mainItem.itemType === types_1.ITEM_TYPE.COMPONENT && mainItem.connectedSide === null) ||
            (mainItem.itemType === types_1.ITEM_TYPE.PANEL && mainItem.connectedSide === types_1.CONNECTED_FACE.SIDE)
            ? types_1.ACTION_ON_FASTENER_VISUALIZATION_FAILURE.DO_NOTHING
            : types_1.ACTION_ON_FASTENER_VISUALIZATION_FAILURE.APPLY_SPHERE;
        return (0, FastenersUtils_1.updateCombinedFastenersForConnection)(mainObject, connectedObject, mainItem, connectedItem, connectionObject, fastenerItems, actionTypeOnFailure);
    }
    setConnection(snapData, actionType, fastenerItemNumber, visualizationParams, isDeletedFastener = false) {
        var _a, _b;
        const connectionObject = ConnectionManager.createConnectionObject(snapData, actionType, isDeletedFastener);
        if (!connectionObject) {
            return Promise.resolve(null);
        }
        const mainObject = snapData.mountedObject;
        const connectedObject = snapData.neighborObject;
        this.setConnectionObject(mainObject, connectedObject, connectionObject);
        let connectionObjectPromise = Promise.resolve(connectionObject);
        let resolvedFastenerItemNumber = fastenerItemNumber;
        let resolvedVisualizationParams = visualizationParams;
        if (!resolvedFastenerItemNumber) {
            const aiFastenerDefault = ConnectionManager.getAiFastenerDefaultForConnection(mainObject, connectedObject, connectionObject);
            if (aiFastenerDefault) {
                resolvedFastenerItemNumber = aiFastenerDefault.itemNumber;
                resolvedVisualizationParams = Object.assign(Object.assign({}, resolvedVisualizationParams), { distanceToTheEdge: (_a = aiFastenerDefault.distanceToTheEdge) !== null && _a !== void 0 ? _a : undefined, holeDepth: (_b = aiFastenerDefault.holeDepth) !== null && _b !== void 0 ? _b : undefined });
            }
        }
        if (!utils_1.Utils.isWithoutFastenersPair(mainObject, connectedObject)) {
            connectionObjectPromise = (0, FastenersUtils_1.updateFastenersForConnection)(mainObject, connectedObject, connectionObject, resolvedFastenerItemNumber, resolvedVisualizationParams, types_1.ACTION_ON_FASTENER_VISUALIZATION_FAILURE.APPLY_SPHERE);
        }
        return connectionObjectPromise;
    }
    static getAiFastenerDefaultForConnection(mainObject, connectedObject, connectionObject) {
        var _a, _b, _c, _d, _e;
        if (((_a = mainObject.userData) === null || _a === void 0 ? void 0 : _a.aiAssemblyId) !== ((_b = connectedObject.userData) === null || _b === void 0 ? void 0 : _b.aiAssemblyId)) {
            return undefined;
        }
        const connectionType = String(connectionObject.getConnection().connectionType);
        const mainDefaults = (_c = mainObject.userData) === null || _c === void 0 ? void 0 : _c.aiFastenerDefaults;
        const connectedDefaults = (_d = connectedObject.userData) === null || _d === void 0 ? void 0 : _d.aiFastenerDefaults;
        return (_e = mainDefaults === null || mainDefaults === void 0 ? void 0 : mainDefaults[connectionType]) !== null && _e !== void 0 ? _e : connectedDefaults === null || connectedDefaults === void 0 ? void 0 : connectedDefaults[connectionType];
    }
    setConnectionObject(mainObject, connectedObject, connectionObject) {
        var _a;
        const mainConnectionItem = connectionObject.getConnection().items.find((item) => item.isMain);
        const connectedConnectionItem = connectionObject.getConnection().items.find((item) => !item.isMain);
        if (!mainConnectionItem || !connectedConnectionItem) {
            return;
        }
        if (!this.connections.has(mainConnectionItem.uuid)) {
            this.connections.set(mainConnectionItem.uuid, new Map());
        }
        (_a = this.connections.get(mainConnectionItem.uuid)) === null || _a === void 0 ? void 0 : _a.set(connectedConnectionItem.uuid, connectionObject);
        this.viewer.getScene().add(connectionObject);
        mainObject.addConnectionItems(connectedConnectionItem);
        connectedObject.addConnectionItems(mainConnectionItem);
    }
    resetConnection(firstObject, secondObject) {
        const connectionObject = this.findConnectionObjectBetween(firstObject.uuid, secondObject.uuid);
        if (!connectionObject) {
            return;
        }
        const mainConnectionItem = connectionObject.getConnection().items.find((item) => item.isMain);
        const connectedConnectionItem = connectionObject.getConnection().items.find((item) => !item.isMain);
        if (!mainConnectionItem || !connectedConnectionItem) {
            return;
        }
        const mainObject = mainConnectionItem.uuid === firstObject.uuid ? firstObject : secondObject;
        const connectedObject = mainConnectionItem.uuid === firstObject.uuid ? secondObject : firstObject;
        const mainObjectConnections = this.connections.get(mainObject.uuid);
        mainObjectConnections === null || mainObjectConnections === void 0 ? void 0 : mainObjectConnections.delete(connectedObject.uuid);
        if (!(mainObjectConnections === null || mainObjectConnections === void 0 ? void 0 : mainObjectConnections.size)) {
            this.connections.delete(mainObject.uuid);
        }
        connectionObject.removeFromParent();
        mainObject.removeConnectionItems(connectedConnectionItem.uuid);
        connectedObject.removeConnectionItems(mainConnectionItem.uuid);
    }
    addConnection(snapData) {
        var _a;
        const mainItem = snapData.mountedObject;
        let fastenerItemNumber;
        let visualizationParams;
        if (this.viewer.getDesignProMain().copyInProgress && mainItem.copyInfo) {
            const copyFastenersInfo = mainItem.copyInfo.fasteners;
            for (let i = 0; i < copyFastenersInfo.length; i += 1) {
                const fastenerData = copyFastenersInfo[i];
                if (fastenerData.toOriginObject === ((_a = snapData.neighborObject.copyInfo) === null || _a === void 0 ? void 0 : _a.originObjectId)) {
                    fastenerItemNumber = fastenerData.fastenerItemNumber;
                    const { distanceToTheEdge, holeDepth } = fastenerData;
                    visualizationParams = {
                        distanceToTheEdge,
                        holeDepth,
                    };
                    break;
                }
            }
        }
        return this.setConnection(snapData, types_1.ACTION_TYPE.ADD, fastenerItemNumber, visualizationParams);
    }
    updateConnection(snapData, transformation) {
        var _a;
        const mainObject = snapData.mountedObject;
        const connectedObject = snapData.neighborObject;
        const connectionObject = (_a = this.findConnectionObjectBetween(mainObject.uuid, connectedObject.uuid)) !== null && _a !== void 0 ? _a : null;
        if (transformation) {
            connectionObject === null || connectionObject === void 0 ? void 0 : connectionObject.transformFastenersAndSphere(transformation);
            connectionObject === null || connectionObject === void 0 ? void 0 : connectionObject.showFasteners();
            return Promise.resolve(connectionObject);
        }
        const fastenerItemNumber = connectionObject === null || connectionObject === void 0 ? void 0 : connectionObject.getConnection().fastenerItemNumber;
        const visualizationParams = {
            distanceToTheEdge: connectionObject === null || connectionObject === void 0 ? void 0 : connectionObject.getConnection().distanceToTheEdge,
        };
        const isDeletedFastener = connectionObject === null || connectionObject === void 0 ? void 0 : connectionObject.getConnection().isDeletedFastener;
        this.resetConnection(mainObject, connectedObject);
        return this.setConnection(snapData, types_1.ACTION_TYPE.UPDATE, fastenerItemNumber, visualizationParams, isDeletedFastener);
    }
    updateConnections(object, objectTransformation, updatedObjectsUUIDs = new Set()) {
        if (!object || (0, utils_3d_1.isFastener)(object)) {
            return { fastenersVisualizationPromises: [], errors: [], warnings: [], objectsToHighlightInRed: [] };
        }
        const { viewer } = this;
        const objectsNearby = utils_1.Utils.getObjectsNearby(object, viewer);
        const { connectedObjectsData, errors, warnings, objectsToHighlightInRed } = utils_1.Utils.getConnectedObjectsDataAndErrors(object, objectsNearby, viewer, updatedObjectsUUIDs);
        const previouslyConnectedItems = object.connectedItems;
        const updatedObjectsData = connectedObjectsData.filter((connectedObjectData) => previouslyConnectedItems.find((connectedItem) => connectedItem.uuid === connectedObjectData.object.uuid));
        const addedObjectsData = connectedObjectsData.filter((connectedObjectData) => !previouslyConnectedItems.some((connectedItem) => connectedItem.uuid === connectedObjectData.object.uuid));
        const removedItems = previouslyConnectedItems.filter((connectedItem) => !connectedObjectsData.some((connectedObjectData) => connectedItem.uuid === connectedObjectData.object.uuid));
        /* Update existing connections */
        const fastenersPromisesForUpdatedConnections = updatedObjectsData.map((connectedObjectData) => {
            const neighborObjectUUID = connectedObjectData.object.uuid;
            const mainObjectUUID = connectedObjectData.mountedObject.uuid;
            const wasNeighborObjectUpdated = updatedObjectsUUIDs.has(neighborObjectUUID);
            // In the case when multiple objects have been selected and transformed,
            // we should update connections only for the main item in a pair of
            // connected items (in order to avoid double updating).
            if (wasNeighborObjectUpdated && neighborObjectUUID === mainObjectUUID) {
                return Promise.resolve(null);
            }
            return this.updateConnection(connectedObjectData, wasNeighborObjectUpdated ? objectTransformation : undefined);
        });
        /* Add new connections */
        const fastenersPromisesForNewConnections = [];
        const { inProgressAddConnections } = this;
        addedObjectsData.forEach((connectedObjectData) => {
            if (!inProgressAddConnections.some((inProgress) => {
                return ((inProgress.firstObjectUuid === connectedObjectData.neighborObject.uuid &&
                    inProgress.secondObjectUuid === connectedObjectData.mountedObject.uuid) ||
                    (inProgress.secondObjectUuid === connectedObjectData.neighborObject.uuid &&
                        inProgress.firstObjectUuid === connectedObjectData.mountedObject.uuid));
            })) {
                inProgressAddConnections.push({
                    firstObjectUuid: connectedObjectData.mountedObject.uuid,
                    secondObjectUuid: connectedObjectData.neighborObject.uuid,
                });
                fastenersPromisesForNewConnections.push(this.addConnection(connectedObjectData));
            }
        });
        /* Remove old connections */
        removedItems.forEach((connectionItem) => {
            const connectionItemObject = viewer.getObjectById(connectionItem.uuid);
            if (!connectionItemObject) {
                return;
            }
            this.resetConnection(object, connectionItemObject);
        });
        const fastenersVisualizationPromises = fastenersPromisesForUpdatedConnections.concat(fastenersPromisesForNewConnections);
        return { fastenersVisualizationPromises, errors, warnings, objectsToHighlightInRed };
    }
    clearInProgressConnections() {
        this.inProgressAddConnections = [];
    }
    static createConnectionObject(snapData, actionType, isDeletedFastener = false) {
        var _a;
        const mainObject = snapData.mountedObject;
        const connectedObject = snapData.neighborObject;
        const snapPosition = utils_1.Utils.computeSnapPosition(mainObject, connectedObject);
        if (!snapPosition) {
            return null;
        }
        // Find type of connection.
        const connectionType = ConnectionManager.getConnectionType(mainObject, connectedObject);
        const isAngled = connectionType === types_1.CONNECTION_TYPE.ANGLED;
        // Find objects' connected faces and connected end faces if any.
        const mainObjectConnectedFace = utils_1.ConnectionUtils.getConnectedFace(mainObject, snapPosition, isAngled);
        const connectedObjectConnectedFace = utils_1.ConnectionUtils.getConnectedFace(connectedObject, snapPosition);
        let mainObjectConnectedEndFace = null;
        let connectedObjectConnectedEndFace = null;
        if (mainObjectConnectedFace === types_1.CONNECTED_FACE.END) {
            mainObjectConnectedEndFace = (0, utils_3d_1.areVectorsEqual)(utils_1.Utils.getNearestPoint(snapPosition, utils_1.Utils.getEndFacePointsForExtrusion(mainObject)), mainObject.position)
                ? types_1.CONNECTED_END_FACE.A
                : types_1.CONNECTED_END_FACE.B;
        }
        if (connectedObjectConnectedFace === types_1.CONNECTED_FACE.END) {
            connectedObjectConnectedEndFace = (0, utils_3d_1.areVectorsEqual)(utils_1.Utils.getNearestPoint(snapPosition, utils_1.Utils.getEndFacePointsForExtrusion(connectedObject)), connectedObject.position)
                ? types_1.CONNECTED_END_FACE.A
                : types_1.CONNECTED_END_FACE.B;
        }
        // Find width of perpendicular extrusion.
        const objectConnectedBySide = mainObjectConnectedFace === types_1.CONNECTED_FACE.SIDE ? mainObject : connectedObject;
        const objectConnectedByEnd = mainObjectConnectedFace === types_1.CONNECTED_FACE.END ? mainObject : connectedObject;
        const extrusionWidth = connectionType === types_1.CONNECTION_TYPE.PERPENDICULAR
            ? utils_1.Utils.calculateCollidedWidth(objectConnectedBySide.directionNormal, (0, utils_3d_1.getAABBox)(objectConnectedBySide), objectConnectedByEnd.directionNormal, (0, utils_3d_1.getAABBox)(objectConnectedByEnd))
            : undefined;
        // Find intersection rectangle between panel and extrusion.
        let intersectionRectangle;
        if ((0, utils_3d_1.isPanel)(connectedObject)) {
            intersectionRectangle = utils_1.Utils.intersectionRectangle(connectedObject, mainObject);
        }
        else if ((0, utils_3d_1.isPanel)(mainObject)) {
            intersectionRectangle = utils_1.Utils.intersectionRectangle(mainObject, connectedObject);
        }
        // Find angle and the longest slot number for angled connection.
        const [connectionExtrusionAngle, longestSlotNumber] = connectionType === types_1.CONNECTION_TYPE.ANGLED
            ? utils_1.Utils.getAngleAndLongestSlotNumbersForAngledConnection(mainObject, connectedObject)
            : [];
        const slotNumbersWithDistanceToSnappingPoint = [];
        const mainObjectComponentType = mainObject.partDetails.componentType;
        // Find distance from endFace A to snappingPoint for Door Handles
        if ([types_1.COMPONENT_TYPE.DELUXE_DOOR_HANDLE, types_1.COMPONENT_TYPE.FURNITURE_STYLE_DOOR_HANDLE].includes(mainObjectComponentType) &&
            (0, utils_3d_1.isExtrusion)(connectedObject)) {
            const distanceToExtrusionEndFaceA = utils_1.Utils.getDistanceFromDoorHandleToExtrusionEndFaceA(mainObject, connectedObject);
            slotNumbersWithDistanceToSnappingPoint.push({
                slotNumber: snapData.slotNumbers[0],
                distance: distanceToExtrusionEndFaceA,
            });
        }
        // Find distance from endFace A to leveling foot / stem caster
        if ([types_1.COMPONENT_TYPE.FOOT, types_1.COMPONENT_TYPE.STEM_CASTER].includes(mainObjectComponentType) &&
            snapData.numberOfSnappedSnappingPoints === 1 &&
            (0, utils_3d_1.isComponent)(connectedObject)) {
            const connectedExtrusionId = (_a = connectedObject.connectedItems.find((item) => !item.isMain)) === null || _a === void 0 ? void 0 : _a.uuid;
            const connectedExtrusion = connectedExtrusionId &&
                utils_1.Utils.getObjectByUUID(Viewer_1.default.instance.getScene(), connectedExtrusionId);
            if (connectedExtrusion && (0, utils_3d_1.isExtrusion)(connectedExtrusion)) {
                slotNumbersWithDistanceToSnappingPoint.push(utils_1.Utils.getDistanceFromFootComponentToExtrusionEndFaceA(mainObject, connectedExtrusion));
            }
        }
        // Create connection items and connection.
        const mainConnectionItem = ConnectionManager.createConnectionItem(true, mainObject, {
            connectedSide: mainObjectConnectedFace,
            endFace: mainObjectConnectedEndFace,
            extrusionWidth,
            intersectionRectangle,
            slotNumbers: snapData.slotNumbers,
            numberOfSnappedSnappingPoints: snapData.numberOfSnappedSnappingPoints,
            snappedInboundPointsIndices: snapData.mountedObjectPointsIndices,
            longestSlotNumberForAngledExtrusion: longestSlotNumber,
            connectionExtrusionAngle,
        });
        const connectedConnectionItem = ConnectionManager.createConnectionItem(false, connectedObject, {
            connectedSide: connectedObjectConnectedFace,
            endFace: connectedObjectConnectedEndFace,
            extrusionWidth,
            intersectionRectangle,
            slotNumbers: snapData.slotNumbers,
            numberOfSnappedSnappingPoints: snapData.numberOfSnappedSnappingPoints,
            snappedInboundPointsIndices: snapData.mountedObjectPointsIndices,
            longestSlotNumberForAngledExtrusion: longestSlotNumber,
            connectionExtrusionAngle,
            slotNumbersWithDistanceToSnappingPoint,
        });
        let extrusionSideHeightConnectedByEnd;
        if (mainObject.type === types_1.ITEM_TYPE.EXTRUSION &&
            connectedObject.type === types_1.ITEM_TYPE.EXTRUSION &&
            connectionType === types_1.CONNECTION_TYPE.PERPENDICULAR) {
            extrusionSideHeightConnectedByEnd = utils_1.Utils.getExtrusionSideHeightConnectedByEnd(mainObject, connectedObject);
        }
        const connection = {
            actionType,
            connectionType,
            connectionUuid: '',
            applicableFastenerTypes: utils_1.ConnectionUtils.getApplicableFastenerTypes(mainObject, connectedObject, connectionType),
            items: [mainConnectionItem, connectedConnectionItem],
            extrusionSideHeightConnectedByEnd,
            isDeletedFastener,
        };
        const connectionObject = new ConnectionObject_3d_1.default(connection, mainObject, connectedObject);
        connectionObject.setAddFastenersCallback(addFastenersCallback);
        connectionObject.setRemoveFastenersCallback(removeFastenersCallback);
        return connectionObject;
    }
    static getConnectionType(mainObject, connectedObject) {
        let connectionType;
        if ((0, utils_3d_1.isComponent)(mainObject) || (0, utils_3d_1.isComponent)(connectedObject)) {
            connectionType = types_1.CONNECTION_TYPE.COMPONENT;
        }
        else if ((0, utils_3d_1.isPanel)(mainObject) && (0, utils_3d_1.isExtrusion)(connectedObject)) {
            connectionType = utils_1.ConnectionUtils.getConnectionTypeBetweenPanelAndExtrusion(mainObject, connectedObject);
        }
        else if ((0, utils_3d_1.isPanel)(connectedObject) && (0, utils_3d_1.isExtrusion)(mainObject)) {
            connectionType = utils_1.ConnectionUtils.getConnectionTypeBetweenPanelAndExtrusion(connectedObject, mainObject);
        }
        else {
            connectionType = utils_1.ConnectionUtils.getConnectionTypeBetweenExtrusions(mainObject, connectedObject);
        }
        return connectionType;
    }
    static cloneConnectionItem(origin, newId = undefined) {
        var _a, _b;
        return {
            uuid: newId !== null && newId !== void 0 ? newId : origin.uuid,
            isMain: origin.isMain,
            itemNumber: origin.itemNumber,
            itemType: origin.itemType,
            componentType: origin.componentType,
            connectedSide: origin.connectedSide,
            size: origin.size,
            geomkernelPosition: (_a = origin.geomkernelPosition) !== null && _a !== void 0 ? _a : origin.position,
            geomkernelPanelSize: (_b = origin.geomkernelPanelSize) !== null && _b !== void 0 ? _b : origin.panelSize,
            position: origin.position,
            panelSize: origin.panelSize,
            rotation: origin.rotation,
            endFace: origin.endFace,
            extrusionWidth: origin.extrusionWidth,
            intersectionRectangle: origin.intersectionRectangle,
            slotNumbers: origin.slotNumbers,
            numberOfSnappedSnappingPoints: origin.numberOfSnappedSnappingPoints,
            snappedInboundPointsIndices: origin.snappedInboundPointsIndices,
            longestSlotNumberForAngledExtrusion: origin.longestSlotNumberForAngledExtrusion,
            connectionExtrusionAngle: origin.connectionExtrusionAngle,
            slotNumbersWithDistanceToSnappingPoint: origin.slotNumbersWithDistanceToSnappingPoint,
            connection: origin.connection,
        };
    }
    static createConnectionItem(isMain, object, connectionInfo) {
        var _a, _b;
        return {
            uuid: object.uuid,
            isMain,
            itemNumber: object.partDetails.itemNumber,
            itemType: object.type,
            size: object.getLength(),
            geomkernelPosition: object.position,
            geomkernelPanelSize: object.getSize(),
            position: (_a = object.originalPosition) !== null && _a !== void 0 ? _a : object.position,
            panelSize: (_b = object.originalPanelSize) !== null && _b !== void 0 ? _b : object.getSize(),
            rotation: {
                x: object.quaternion.x,
                y: object.quaternion.y,
                z: object.quaternion.z,
                w: object.quaternion.w,
            },
            componentType: object.partDetails.componentType,
            connectedSide: connectionInfo.connectedSide,
            endFace: connectionInfo.endFace,
            extrusionWidth: connectionInfo.extrusionWidth,
            intersectionRectangle: connectionInfo.intersectionRectangle,
            slotNumbers: connectionInfo.slotNumbers,
            numberOfSnappedSnappingPoints: connectionInfo.numberOfSnappedSnappingPoints,
            snappedInboundPointsIndices: connectionInfo.snappedInboundPointsIndices,
            longestSlotNumberForAngledExtrusion: connectionInfo.longestSlotNumberForAngledExtrusion,
            connectionExtrusionAngle: connectionInfo.connectionExtrusionAngle,
            slotNumbersWithDistanceToSnappingPoint: connectionInfo.slotNumbersWithDistanceToSnappingPoint,
        };
    }
    getObjectRelatedConnectionObjects(object) {
        return object.connectedItems.reduce((connections, item) => {
            const connectionObject = this.findConnectionObjectBetween(object.uuid, item.uuid);
            if (connectionObject) {
                connections.push(connectionObject);
            }
            return connections;
        }, []);
    }
    getFastenerRelatedConnectionObjects(fastener) {
        const [firstItem, secondItem] = fastener.connectedItems;
        if (!firstItem || !secondItem) {
            return [];
        }
        const connection = this.findConnectionObjectBetween(firstItem.uuid, secondItem.uuid);
        return connection ? [connection] : [];
    }
}
exports.default = ConnectionManager;
